import React from "react";
import { images, pillars } from "../data/content";
import { Reveal } from "./Reveal";
export function Intro() {
  return <section id="chatterie" className="bg-ink py-24 lg:py-36" data-id="element-129" data-mp="27fgn9c9xwgqq">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-130" data-mp="2lgjavtgl1z3r">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-12" data-id="element-131" data-mp="2lf84dlvr6d8y">
          <Reveal className="lg:col-span-7" data-id="element-132" data-mp="2ghyb1v58thfu">
            <h2 className="font-display text-4xl leading-[1.05] text-cream sm:text-5xl lg:text-6xl" data-id="element-133" data-mp="2gf3ony2o5mjs">
              Un élevage professionnel de Bengal, <span className="italic text-sage" data-id="element-134" data-mp="1nt0r7nldvckz">pensé comme une maison.</span>
            </h2>
            <div className="mt-10 grid gap-6 text-base leading-relaxed text-stone sm:grid-cols-2" data-id="element-135" data-mp="22hnjsr00u0u5">
              <p data-id="element-136" data-mp="1xpx21zyr8asp">
                Bienvenue à la chatterie Pardus Dei, élevage de chats Bengal en Ardèche, situé à 1h30 de Lyon. Nous
                sommes spécialisés dans la sélection et l'élevage de chatons Bengal LOOF de qualité.
              </p>
              <p data-id="element-137" data-mp="14znfr1x9xyvr">
                Nos chatons grandissent au cœur de notre foyer, socialisés dès leurs premiers jours. Ils rejoignent
                ensuite leur famille partout en France et dans le monde entier.
              </p>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={0.05} data-id="element-138" data-mp="bhgacbwbwkhr">
            <figure className="relative" data-id="element-139" data-mp="fhidyqlmjnzo">
              <img src={images.home} alt="Un Bengal se reposant dans la maison de la chatterie en Ardèche" className="aspect-[4/5] w-full rounded-sm object-cover lg:aspect-[4/5]" data-id="element-140" data-mp="fggr7ov8xd24" />
              <figcaption className="mt-3 text-xs text-stone" data-id="element-141" data-mp="3jxt7830nwcaq">La maison familiale, Ardèche</figcaption>
            </figure>
          </Reveal>
        </div>

        <div className="mt-24 grid border-t border-line md:grid-cols-3" data-id="element-142" data-mp="3sxfz9y7i45r4">
          {pillars.map((p, i) => <Reveal key={p.title} delay={i * 0.05} className={`py-10 md:px-8 ${i === 0 ? "md:pl-0" : "md:border-l md:border-line"} ${i > 0 ? "border-t border-line md:border-t-0" : ""}`} data-id="element-143" data-mp="136t47e5clzzk" data-mpi={i}>
              <h3 className="font-display text-3xl italic text-sage" data-id="element-144" data-mp="306xeauk8dxhi">{p.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-stone" data-id="element-145" data-mp="3e89t32nnnt1t">{p.text}</p>
            </Reveal>)}
        </div>
      </div>
    </section>;
}